import React from 'react';
import SvgIcon from '../SvgIconWrapper';

interface UBeamIconProps {
  size?: number;
  color?: string;
}

const UBeamIcon: React.FC<UBeamIconProps> = (props) => (
  <SvgIcon {...props} className="sx-icon-ubeam">
    {
      <path d="M9.018 2.898h5.848c0.065 0 0.117 0.052 0.117 0.117v0 0.675c0 0.065-0.052 0.117-0.117 0.117v0h-3.851c-0.466 0-0.843 0.378-0.843 0.843v14.575c0 0.525 0.426 0.951 0.951 0.951h3.743c0.065 0 0.117 0.052 0.117 0.117v0 0.69c0 0.065-0.052 0.117-0.117 0.117v0h-5.848z"></path>
    }  </SvgIcon>
);

export default UBeamIcon;
